// localize the requires here
/* eslint-disable @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports */

// google oauth btn
export const googleDarkDisabled: string = require("./btn_google_dark_disabled_ios.svg");
export const googleDarkFocus: string = require("./btn_google_dark_focus_ios.svg");
export const googleDarkNormal: string = require("./btn_google_dark_normal_ios.svg");
export const googleDarkPressed: string = require("./btn_google_dark_pressed_ios.svg");
export const googleLightDisabled: string = require("./btn_google_light_disabled_ios.svg");
export const googleLightFocus: string = require("./btn_google_light_focus_ios.svg");
export const googleLightNormal: string = require("./btn_google_light_normal_ios.svg");
export const googleLightPressed: string = require("./btn_google_light_pressed_ios.svg");

// google chrome logo
export const googleChromeLogo: string = require("./google-chrome-logo.svg");
export { ChromeIcon } from "./ChromeIcon";

// google calendar logo
export const googleCalendarLogo: string = require("./google-calendar-logo-horizontal.png");
export const googleGsuiteLogo: string = require("./google-gsuite-logo-horizontal.png");
export const googleGsuiteIcon: string = require("./google-gsuite-icon.png");
